<template>
    <div class="Minister-top Ministerborder">
        <div class="Minister-top-top Ministerbackground">
            <div class="Minister-top-left Minister-top-color">设置分类</div>
            <div
                class="Minister-top-right Minister-top-color"
                @click="Retract"
                style="cursor:pointer"
            >{{Retractcontent}}</div>
        </div>
        <div class="classification" v-if="Retracttypt">
            <div class="classification_left">
                <div
                    class="classification_content"
                    v-for="(item,index) in CountryList"
                    :key="index"
                >
                    <div class="station_left">
                        <div class="station">{{item.name}}：</div>
                    </div>
                    <div class="station_right">
                        <!-- <div>Us station classification</div> -->
                        <el-button type="primary" @click="Seleclassification(item.ct)">选择分类</el-button>
                    </div>
                </div>
            </div>
            <!-- 分类节点 -->
            <!-- <el-popover placement="right" width="400" trigger="click">
                我
                
                <el-button slot="reference">click 激活</el-button>
            </el-popover>-->
            <el-dialog :visible.sync="SeleclassificationType">
                <div class="classification_right">
                    <div class="elasticFrame">
                        <div class="elasticFrame_classification">分类</div>
                        <el-input v-model="input" placeholder="请输入内容" @focus="iptFoucs"></el-input>
                    </div>

                    <div class="elasticFrame">
                        <div class="elasticFrame_classification">节点ID</div>
                        <el-input v-model="input" placeholder="请输入内容"></el-input>
                    </div>
                    <!-- <div class="elasticFrame">
                    <div class="elasticFrame_classification">最佳模板</div>
                    <el-select @change="chanOptimum" v-model="optimum" placeholder="选择最佳模板">
                        <el-option
                            v-for="(item,index) in optimumlist"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                    </div>-->
                    <div class="elasticFrame">
                        <div class="elasticFrame_classification">分类模板</div>
                        <el-select @change="chanSetup" v-model="setup" placeholder="选择分类模板">
                            <el-option
                                v-for="(item,index) in setuplist"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="elasticFrame">
                        <div class="elasticFrame_classification">分类属性</div>
                        <el-input v-model="input" placeholder="请输入内容"></el-input>
                    </div>
                    <div class="Preservation">保存</div>
                </div>
            </el-dialog>
            <div>
                <!--modal-append-to-body="false" -->
                <el-dialog title="选择目录" :visible.sync="release">
                    <el-tabs type="border-card">
                        <el-tab-pane label="常用分类">
                            <el-input v-model="input" placeholder="输入产品关键字"></el-input>
                            <p>你有以下10个常用目录</p>
                            <p>
                                点击直接选择该目录
                                无数据
                            </p>
                        </el-tab-pane>
                        <el-tab-pane label="所有分类">
                            <!-- <el-input v-model="input" placeholder="输入产品关键字"></el-input>
                            <el-button disabled type="primary">确定</el-button>-->
                            <!-- <el-cascader :options="options">
                                <template slot-scope="{ node, data }">
                                    <span>{{ data.label }}</span>
                                    <span v-if="!node.isLeaf">({{ data.children.length }})</span>
                                </template>
                            </el-cascader>-->
                            <!-- <div id="unpublic" class="classify-box">
                                <div class="classify-out">
                                    <div class="classify-item">
                                        服装-Bekleidung
                                        <i class="el-icon-caret-right"></i>
                                    </div>
                                    <div class="classify-item">
                                        大型电器-Elektro-Großgeräte
                                        <i class="el-icon-caret-right"></i>
                                    </div>
                                </div>
                                <div class="classify-out">
                                    <div class="classify-item">
                                        钱包，身份证和卡片盒-Geldbörsen, Ausweis- &amp; Kartenhüllen
                                        <i
                                            class="el-icon-caret-right"
                                        ></i>
                                    </div>
                                </div>
                                <div class="classify-out">
                                    <div class="classify-item">
                                        鞋垫-Einlegesohlen
                                        <i class="el-icon-caret-right"></i>
                                    </div>
                                </div>
                            </div>-->
                            <el-form>
                                <el-form-item>{{class_model.join(' / ')}}</el-form-item>
                                <el-form-item>
                                    <el-button
                                        size="mini"
                                        type="primary"
                                        @click="choose_sure2"
                                        v-if="!is_son_class"
                                    >确定</el-button>
                                    <el-button size="mini" type="primary" disabled v-else>确定</el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-input
                                        type="text"
                                        size="mini"
                                        placeholder="输入产品关键字"
                                        v-model="choose_search_all"
                                    ></el-input>
                                </el-form-item>
                            </el-form>
                            <div
                                class="classify-box"
                                id="unpublic"
                                v-if="!choose_search_all2.length > 0"
                            >
                                <div class="classify-out">
                                    <div
                                        class="classify-item"
                                        :class="{active: index === first_index2}"
                                        v-for="(item,index) in classification2"
                                        :key="index"
                                        @click="firstClass2(item,index)"
                                    >
                                        {{item.node_name_chinese}}-{{item.node_name}}
                                        <i
                                            v-if="item.sonClass"
                                            class="el-icon-caret-right"
                                        ></i>
                                    </div>
                                </div>
                                <div class="classify-out" v-if="this.second_class_list2.length > 0">
                                    <div
                                        class="classify-item"
                                        :class="{active: index === second_index2}"
                                        v-for="(item,index) in second_class_list2"
                                        :key="index"
                                        @click="secondClass2(item,index)"
                                    >
                                        {{item.node_name_chinese}}-{{item.node_name}}
                                        <i
                                            v-if="item.sonClass"
                                            class="el-icon-caret-right"
                                        ></i>
                                    </div>
                                </div>
                                <div class="classify-out" v-if="this.third_class_list2.length > 0">
                                    <div
                                        class="classify-item"
                                        :class="{active: index === third_index2}"
                                        v-for="(item,index) in third_class_list2"
                                        :key="index"
                                        @click="thirdClass2(item,index)"
                                    >
                                        {{item.node_name_chinese}}-{{item.node_name}}
                                        <i
                                            v-if="item.sonClass"
                                            class="el-icon-caret-right"
                                        ></i>
                                    </div>
                                </div>
                                <div class="classify-out" v-if="this.fouth_class_list2.length > 0">
                                    <div
                                        class="classify-item"
                                        :class="{active: index === fouth_index2}"
                                        v-for="(item,index) in fouth_class_list2"
                                        :key="index"
                                        @click="fouthClass2(item,index)"
                                    >
                                        {{item.node_name_chinese}}-{{item.node_name}}
                                        <i
                                            v-if="item.sonClass"
                                            class="el-icon-caret-right"
                                        ></i>
                                    </div>
                                </div>
                                <div class="classify-out" v-if="this.fifth_class_list2.length > 0">
                                    <div
                                        class="classify-item"
                                        :class="{active: index === fifth_index2}"
                                        v-for="(item,index) in fifth_class_list2"
                                        :key="index"
                                        @click="fifthClass2(item,index)"
                                    >
                                        {{item.node_name_chinese}}-{{item.node_name}}
                                        <i
                                            v-if="item.sonClass"
                                            class="el-icon-caret-right"
                                        ></i>
                                    </div>
                                </div>
                                <div class="classify-out" v-if="this.sixth_class_list2.length > 0">
                                    <div
                                        class="classify-item"
                                        :class="{active: index === sixth_index2}"
                                        v-for="(item,index) in sixth_class_list2"
                                        :key="index"
                                        @click="sixthClass2(item,index)"
                                    >
                                        {{item.node_name_chinese}}-{{item.node_name}}
                                        <i
                                            v-if="item.sonClass"
                                            class="el-icon-caret-right"
                                        ></i>
                                    </div>
                                </div>
                            </div>

                            <div class="classify-box" v-else>
                                <el-row class="recent-row">
                                    <div
                                        v-for="item in recent_search_all(class_all)"
                                        :key="item"
                                        @click="choose"
                                    >{{item}}</div>
                                    <!--<p v-if="choose_list_search.length === 0">无数据</p>-->
                                </el-row>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
import { ajaxPost, Baseurl } from "../../../../api/api/api";
export default {
    data() {
        return {
            Retractcontent: "展开",
            Retracttypt: false,
            SeleclassificationType: false,
            input: "",
            CountryList: [
                { name: "美国站", ct: "US" },
                { name: "英国站", ct: "EN" },
                { name: "法国站", ct: "FR" },
                { name: "德国站", ct: "DE" },
                { name: "意大利站", ct: "IT" },
                { name: "西班牙站", ct: "ES" },
                { name: "加拿大站", ct: "CA" },
                { name: "墨西哥站", ct: "MX" },
                { name: "荷兰站", ct: "DE" },
                { name: "日本站", ct: "JP" }
            ],
            optimum: "", //最佳模板
            setup: "", //分类模板
            optimumlist: [],
            setuplist: [],
            dialogVisible: true,
            release: false,
            options: [
                {
                    value: "zhinan",
                    label: "指南",
                    children: [
                        {
                            value: "shejiyuanze",
                            label: "设计原则",
                            children: [
                                {
                                    value: "yizhi",
                                    label: "一致"
                                },
                                {
                                    value: "fankui",
                                    label: "反馈"
                                },
                                {
                                    value: "xiaolv",
                                    label: "效率"
                                },
                                {
                                    value: "kekong",
                                    label: "可控"
                                }
                            ]
                        },
                        {
                            value: "daohang",
                            label: "导航",
                            children: [
                                {
                                    value: "cexiangdaohang",
                                    label: "侧向导航"
                                },
                                {
                                    value: "dingbudaohang",
                                    label: "顶部导航"
                                }
                            ]
                        }
                    ]
                },
                {
                    value: "zujian",
                    label: "组件",
                    children: [
                        {
                            value: "basic",
                            label: "Basic",
                            children: [
                                {
                                    value: "layout",
                                    label: "Layout 布局"
                                },
                                {
                                    value: "color",
                                    label: "Color 色彩"
                                },
                                {
                                    value: "typography",
                                    label: "Typography 字体"
                                },
                                {
                                    value: "icon",
                                    label: "Icon 图标"
                                },
                                {
                                    value: "button",
                                    label: "Button 按钮"
                                }
                            ]
                        },
                        {
                            value: "form",
                            label: "Form",
                            children: [
                                {
                                    value: "radio",
                                    label: "Radio 单选框"
                                },
                                {
                                    value: "checkbox",
                                    label: "Checkbox 多选框"
                                },
                                {
                                    value: "input",
                                    label: "Input 输入框"
                                },
                                {
                                    value: "input-number",
                                    label: "InputNumber 计数器"
                                },
                                {
                                    value: "select",
                                    label: "Select 选择器"
                                },
                                {
                                    value: "cascader",
                                    label: "Cascader 级联选择器"
                                },
                                {
                                    value: "switch",
                                    label: "Switch 开关"
                                },
                                {
                                    value: "slider",
                                    label: "Slider 滑块"
                                },
                                {
                                    value: "time-picker",
                                    label: "TimePicker 时间选择器"
                                },
                                {
                                    value: "date-picker",
                                    label: "DatePicker 日期选择器"
                                },
                                {
                                    value: "datetime-picker",
                                    label: "DateTimePicker 日期时间选择器"
                                },
                                {
                                    value: "upload",
                                    label: "Upload 上传"
                                },
                                {
                                    value: "rate",
                                    label: "Rate 评分"
                                },
                                {
                                    value: "form",
                                    label: "Form 表单"
                                }
                            ]
                        },
                        {
                            value: "data",
                            label: "Data",
                            children: [
                                {
                                    value: "table",
                                    label: "Table 表格"
                                },
                                {
                                    value: "tag",
                                    label: "Tag 标签"
                                },
                                {
                                    value: "progress",
                                    label: "Progress 进度条"
                                },
                                {
                                    value: "tree",
                                    label: "Tree 树形控件"
                                },
                                {
                                    value: "pagination",
                                    label: "Pagination 分页"
                                },
                                {
                                    value: "badge",
                                    label: "Badge 标记"
                                }
                            ]
                        },
                        {
                            value: "notice",
                            label: "Notice",
                            children: [
                                {
                                    value: "alert",
                                    label: "Alert 警告"
                                },
                                {
                                    value: "loading",
                                    label: "Loading 加载"
                                },
                                {
                                    value: "message",
                                    label: "Message 消息提示"
                                },
                                {
                                    value: "message-box",
                                    label: "MessageBox 弹框"
                                },
                                {
                                    value: "notification",
                                    label: "Notification 通知"
                                }
                            ]
                        },
                        {
                            value: "navigation",
                            label: "Navigation",
                            children: [
                                {
                                    value: "menu",
                                    label: "NavMenu 导航菜单"
                                },
                                {
                                    value: "tabs",
                                    label: "Tabs 标签页"
                                },
                                {
                                    value: "breadcrumb",
                                    label: "Breadcrumb 面包屑"
                                },
                                {
                                    value: "dropdown",
                                    label: "Dropdown 下拉菜单"
                                },
                                {
                                    value: "steps",
                                    label: "Steps 步骤条"
                                }
                            ]
                        },
                        {
                            value: "others",
                            label: "Others",
                            children: [
                                {
                                    value: "dialog",
                                    label: "Dialog 对话框"
                                },
                                {
                                    value: "tooltip",
                                    label: "Tooltip 文字提示"
                                },
                                {
                                    value: "popover",
                                    label: "Popover 弹出框"
                                },
                                {
                                    value: "card",
                                    label: "Card 卡片"
                                },
                                {
                                    value: "carousel",
                                    label: "Carousel 走马灯"
                                },
                                {
                                    value: "collapse",
                                    label: "Collapse 折叠面板"
                                }
                            ]
                        }
                    ]
                },
                {
                    value: "ziyuan",
                    label: "资源",
                    children: [
                        {
                            value: "axure",
                            label: "Axure Components"
                        },
                        {
                            value: "sketch",
                            label: "Sketch Templates"
                        },
                        {
                            value: "jiaohu",
                            label: "组件交互文档"
                        }
                    ]
                }
            ],
            is_son_class: true, //点击的分类列表是否有下级
            class_all2: [],
            class_all: [],
            classify_item: {},
            node_name: "",
            classification2: [],
            class_model2: [],
            first_index2: -1,
            first_class_text2: "",
            second_class_list2: [],
            second_class_text2: "",
            second_index2: -1,
            third_class_list2: [],
            third_class_text2: "",
            third_index2: -1,
            fouth_class_list2: [],
            fouth_class_text2: "",
            fouth_index2: -1,
            fifth_class_list2: [],
            fifth_class_text2: "",
            fifth_index2: -1,
            sixth_class_list2: [],
            sixth_class_text2: "",
            sixth_index2: -1,

            choose_search_word2: "",

            choose_search_all: "",
            choose_search_all2: "",
            product_classify_placeholder2: [],
            choose_list2: [],
            classifyShow2: false,

            public_data: "",
            class_model: [],
            first_index: -1,
            first_class_text: "",
            second_class_list: [],
            second_class_text: "",
            second_index: -1,
            third_class_list: [],
            third_class_text: "",
            third_index: -1,

            choose_search_word: "",
            product_classify_placeholder: [],
            choose_list: [],
            classifyShow: false,
            //最近搜索列表
            product_recent_selected: [
                "家用电器 / 电视、音响 / 平板电视",
                "图书 / 教材教辅 / 教材",
                "Kindle 商店 / Kindle Unlimited / 包月电子书",
                "图书 / 少儿 / 7-10岁"
            ],
            dialogRecentVisible: false,
            product_template_lists: [],
            good_template_lists: [],
            good_template_id: "",
            shop_list: [],
            attributes: [],

            //shop_selected_id:'',
            search_text: "",
            totalCount: 0,
            currentPage: 1,
            pagesize: 5,
            product_list: [],
            selected_product_list: [],
            datetime_start: "",
            datetime_end: "",
            product_classify_selected: [],
            product_classify_selected2: [],
            classification: "",
            classification_props: {
                value: "name",
                label: "name",
                children: "list"
            },
            public_mult_form: {
                classification: [], //   分类
                node_IDs: [], // 节点ID
                node_ID: "", // 节点ID
                classification_prop: [], //   分类属性
                classification_prop_unit: "", //分类属性单位
                Classification_template: "", //   分类模板
                title_start_add: "", // 开头添加
                title_end_add: "", // 结尾添加
                replace_title_from: "", // 将标题中的
                replace_title_to: "" //替换为
            },
            dialogImageUrl: "",
            dialogVisible: false,
            dialogVisibleError: false,
            dialogVisibleError_text: "",
            node_lists: []
        };
    },
    mounted() {
        // this.class_all = classification_all;
    },
    methods: {
        //最佳模板
        chanOptimum() {},
        //分类模板
        chanSetup() {},
        Retract() {
            this.Retracttypt = !this.Retracttypt;
            if (this.Retractcontent === "展开") {
                this.Retractcontent = "收起";
            } else {
                this.Retractcontent = "展开";
            }
        },
        Seleclassification(ct) {
            this.SeleclassificationType = true;
        },
        iptFoucs() {
            this.release = true;
        },
        classification_prop_select_change(index) {
            this.public_mult_form.classification_prop[index] =
                this.public_mult_form.classification_prop[index].split("-")[0] +
                "-" +
                this.public_mult_form.classification_prop_unit;
        },
        firstClass2(item, index) {
            //是否有下级
            this.is_son_class = item.sonClass;

            this.first_class_text2 =
                item.node_name_chinese + "-" + item.node_name;
            this.class_model2.splice(0, 6);
            this.class_model2.push(this.first_class_text2);
            this.first_index2 = index;

            this.classify_item = item;
            this.node_name = item.node_name;
            //节点ID
            this.public_mult_form.node_ID = item.node_id;
            //最佳模板
            this.good_template_lists = item.best_template;

            this.second_class_text2 = "";
            this.second_class_list2 = [];
            this.third_class_text2 = "";
            this.third_class_list2 = [];
            this.fouth_class_text2 = "";
            this.fouth_class_list2 = [];
            this.fifth_class_text2 = "";
            this.fifth_class_list2 = [];
            // http_noLoading
            //     .post(
            //         this.api.getPublicClass2,
            //         {
            //             store: this.shop_selected_id,
            //             pid: item.id
            //         },
            //         {
            //             headers: {
            //                 authkey: this.user_token,
            //                 sessionid: this.user_id,
            //                 staffid: this.staff_id
            //             }
            //         }
            //     )
            //     .then(res => {
            //         if (res.code === 200) {
            //             if (res.data) {
            //                 this.second_class_list2 = res.data;
            //             } else {
            //                 // this.$message.error('没有下级分类');
            //             }
            //             this.second_index2 = -1;
            //             this.third_index2 = -1;
            //             this.fouth_index2 = -1;
            //             this.fifth_index2 = -1;
            //         }
            //     });
        },
        secondClass2(item, index) {
            //是否有下级
            this.is_son_class = item.sonClass;

            this.second_class_text2 =
                item.node_name_chinese + "-" + item.node_name;
            this.class_model2.splice(1, 5);
            this.class_model2.push(this.second_class_text2);
            this.second_index2 = index;

            this.classify_item = item;
            this.node_name = item.node_name;
            this.public_mult_form.node_ID = item.node_id;
            //最佳模板
            this.good_template_lists = item.best_template;

            this.third_class_text2 = "";
            this.third_class_list2 = [];
            this.fouth_class_text2 = "";
            this.fouth_class_list2 = [];
            this.fifth_class_text2 = "";
            this.fifth_class_list2 = [];
            // http_noLoading
            //     .post(
            //         this.api.getPublicClass2,
            //         {
            //             store: this.shop_selected_id,
            //             pid: item.id
            //         },
            //         {
            //             headers: {
            //                 authkey: this.user_token,
            //                 sessionid: this.user_id,
            //                 staffid: this.staff_id
            //             }
            //         }
            //     )
            //     .then(res => {
            //         if (res.code === 200) {
            //             if (res.data) {
            //                 this.third_class_list2 = res.data;
            //             } else {
            //                 // this.$message.error('没有下级分类');
            //             }
            //             this.third_index2 = -1;
            //             this.fouth_index2 = -1;
            //             this.fifth_index2 = -1;
            //         }
            //     });
        },
        thirdClass2(item, index) {
            //是否有下级
            this.is_son_class = item.sonClass;

            this.third_class_text2 =
                item.node_name_chinese + "-" + item.node_name;
            this.class_model2.splice(2, 4);
            this.class_model2.push(this.third_class_text2);
            this.third_index2 = index;

            this.classify_item = item;
            this.node_name = item.node_name;
            this.public_mult_form.node_ID = item.node_id;
            //最佳模板
            this.good_template_lists = item.best_template;

            this.fouth_class_text2 = "";
            this.fouth_class_list2 = [];
            this.fifth_class_text2 = "";
            this.fifth_class_list2 = [];
            // http_noLoading
            //     .post(
            //         this.api.getPublicClass2,
            //         {
            //             store: this.shop_selected_id,
            //             pid: item.id
            //         },
            //         {
            //             headers: {
            //                 authkey: this.user_token,
            //                 sessionid: this.user_id,
            //                 staffid: this.staff_id
            //             }
            //         }
            //     )
            //     .then(res => {
            //         if (res.code === 200) {
            //             if (res.data) {
            //                 this.fouth_class_list2 = res.data;
            //             } else {
            //                 // this.$message.error('没有下级分类');
            //             }
            //             this.fouth_index2 = -1;
            //             this.fifth_index2 = -1;
            //         }
            //     });
        },
        fouthClass2(item, index) {
            //是否有下级
            this.is_son_class = item.sonClass;

            this.fouth_class_text2 =
                item.node_name_chinese + "-" + item.node_name;
            this.class_model2.splice(3, 3);
            this.class_model2.push(this.fouth_class_text2);
            this.fouth_index2 = index;

            this.classify_item = item;
            this.node_name = item.node_name;
            this.public_mult_form.node_ID = item.node_id;
            //最佳模板
            this.good_template_lists = item.best_template;

            this.fifth_class_text2 = "";
            this.fifth_class_list2 = [];
            // http_noLoading
            //     .post(
            //         this.api.getPublicClass2,
            //         {
            //             store: this.shop_selected_id,
            //             pid: item.id
            //         },
            //         {
            //             headers: {
            //                 authkey: this.user_token,
            //                 sessionid: this.user_id,
            //                 staffid: this.staff_id
            //             }
            //         }
            //     )
            //     .then(res => {
            //         if (res.code === 200) {
            //             if (res.data) {
            //                 this.fifth_class_list2 = res.data;
            //             } else {
            //                 // this.$message.error('没有下级分类');
            //             }
            //             this.fifth_index2 = -1;
            //         }
            //     });
        },
        fifthClass2(item, index) {
            //是否有下级
            this.is_son_class = item.sonClass;

            this.fifth_class_text2 =
                item.node_name_chinese + "-" + item.node_name;
            this.class_model2.splice(4, 2);
            this.class_model2.push(this.fifth_class_text2);
            this.fifth_index2 = index;

            this.classify_item = item;
            this.node_name = item.node_name;
            this.public_mult_form.node_ID = item.node_id;
            //最佳模板
            this.good_template_lists = item.best_template;

            this.sixth_class_text2 = "";
            this.sixth_class_list2 = [];
            // http_noLoading
            //     .post(
            //         this.api.getPublicClass2,
            //         {
            //             store: this.shop_selected_id,
            //             pid: item.id
            //         },
            //         {
            //             headers: {
            //                 authkey: this.user_token,
            //                 sessionid: this.user_id,
            //                 staffid: this.staff_id
            //             }
            //         }
            //     )
            //     .then(res => {
            //         if (res.code === 200) {
            //             if (res.data) {
            //                 this.sixth_class_list2 = res.data;
            //             } else {
            //                 // this.$message.error('没有下级分类');
            //             }
            //             this.sixth_index2 = -1;
            //         }
            //     });
        },
        sixthClass2(item, index) {
            //是否有下级
            this.is_son_class = item.sonClass;

            this.sixth_class_text2 =
                item.node_name_chinese + "-" + item.node_name;
            this.class_model2.splice(5, 1);
            this.class_model2.push(this.sixth_class_text2);
            this.sixth_index2 = index;

            this.classify_item = item;
            this.node_name = item.node_name;
            this.public_mult_form.node_ID = item.node_id;
            //最佳模板
            this.good_template_lists = item.best_template;
        },

        choose_sure2(is_search = false) {
            if (this.good_template_lists[0].value) {
                this.good_template_id = this.good_template_lists[0].value.node_name;
            }
            this.onBestTemplateChange();
            if (!is_search) {
                this.product_classify_selected2 = this.class_model2;
            } else {
                this.product_classify_selected2 =
                    this.classify_item.full_node_name_chinese +
                    "-" +
                    this.classify_item.full_node_name;
            }
            this.classifyShow2 = false;
        },
        choose2(item) {
            var s = item.full_node_name_chinese + "-" + item.full_node_name;
            this.product_classify_selected2 = s;
            this.public_mult_form.node_ID = item.node_id;
            this.good_template_lists = item.best_template;

            if (this.good_template_lists[0].value) {
                this.good_template_id = this.good_template_lists[0].value.node_name;
            }
            this.classify_item = item;
            this.onBestTemplateChange(item.model_name);
            this.classifyShow2 = false;
        },
        recent_show2() {
            this.classifyShow2 = true;
            // http_noLoading
            //     .post(
            //         this.api.getPublicClass2,
            //         {
            //             store: this.shop_selected_id,
            //             pid: 0
            //         },
            //         {
            //             headers: {
            //                 authkey: this.user_token,
            //                 sessionid: this.user_id,
            //                 staffid: this.staff_id
            //             }
            //         }
            //     )
            //     .then(res => {
            //         console.log(res);
            //         if (res.code !== 200) {
            //             this.$message.error(res.error);
            //         } else {
            //             this.classification2 = res.data;
            //         }
            //     })
            //     .catch(e => {
            //         this.$message.error("获取分类模板失败");
            //     });

            //获取所有列表
            if (this.class_all2.length === 0) {
                // http_noLoading
                //     .post(
                //         this.api.getPublicClassAll2,
                //         {
                //             shop_id: this.shop_selected_id
                //         },
                //         {
                //             headers: {
                //                 authkey: this.user_token,
                //                 sessionid: this.user_id,
                //                 staffid: this.staff_id
                //             }
                //         }
                //     )
                //     .then(res => {
                //         if (res.code !== 200) {
                //             this.$message.error(res.error);
                //         } else {
                //             this.class_all2 = res.data;
                //         }
                //     });
            }

            //获取常用模板
            // http_noLoading
            //     .post(
            //         this.api.uploadClassification2,
            //         {
            //             shopId: this.shop_selected_id
            //         },
            //         {
            //             headers: {
            //                 authkey: this.user_token,
            //                 sessionid: this.user_id,
            //                 staffid: this.staff_id
            //             }
            //         }
            //     )
            //     .then(res => {
            //         if (res.code !== 200) {
            //             this.$message.error(res.error);
            //         } else {
            //             this.choose_list2 = res.data;
            //         }
            //     });
        },

        firstClass(item, index) {
            this.first_class_text = item.name;
            this.second_class_text = "";
            this.third_class_text = "";
            this.third_class_list = [];
            this.second_class_list = item.list;
            this.class_model.splice(0, 3);
            this.class_model.push(this.first_class_text);
            this.first_index = index;
            this.second_index = -1;
            this.third_index = -1;
        },
        secondClass(item, index) {
            this.second_class_text = item.name;
            this.third_class_text = "";
            this.third_class_list = item.list;
            this.class_model.splice(1, 2);
            this.class_model.push(this.second_class_text);
            this.second_index = index;
            this.third_index = -1;
        },
        thirdClass(item, index) {
            this.third_class_text = item.name;
            this.class_model.splice(2, 1);
            this.class_model.push(this.third_class_text);
            this.third_index = index;
        },

        recent_search(choose_list) {
            var word = this.choose_search_word;
            return choose_list.filter(function(number) {
                return number.indexOf(word) !== -1;
            });
        },
        recent_search_all(choose_list) {
            var word = this.choose_search_all;
            return choose_list.filter(function(number) {
                return number.indexOf(word) !== -1;
            });
        },
        recent_search_all2(choose_list) {
            var word = this.choose_search_all2;
            return choose_list.filter(function(number) {
                return number.name.indexOf(word) !== -1;
            });
        },
        //点击搜索出的选项
        searchAllItem(id) {
            // this.$http
            //     .post(
            //         this.api.getPublicClassAll2,
            //         {
            //             shop_id: this.shop_selected_id,
            //             id: id
            //         },
            //         {
            //             headers: {
            //                 authkey: this.user_token,
            //                 sessionid: this.user_id,
            //                 staffid: this.staff_id
            //             }
            //         }
            //     )
            //     .then(res => {
            //         if (res.code !== 200) {
            //             this.$message.error(res.error);
            //         } else {
            //             this.classify_item = res.data[0];
            //             this.node_name = res.data[0].node_name;
            //             this.public_mult_form.node_ID = res.data[0].node_id;
            //             //最佳模板
            //             this.good_template_lists = res.data[0].best_template;
            //             this.choose_sure2(true);
            //         }
            //     });
        },
        recent_search2(choose_list) {
            var word = this.choose_search_word2;
            return choose_list.filter(function(number) {
                let name =
                    number.full_node_name_chinese + number.full_node_name;
                return name.indexOf(word) !== -1;
            });
        },
        // 确定搜索 123
        choose_sure() {
            this.product_classify_selected = this.class_model;
            this.classifyShow = false;
        },
        choose(e) {
            var s = e.target.innerText.split("/");
            var f = s.map(function(val, index) {
                return val.trim();
            });
            this.product_classify_selected = f;
            this.classifyShow = false;
        },
        recent_show() {
            this.classifyShow = true;
            this.$http
                .post(
                    this.api.commonTemplate2,
                    {},
                    {
                        headers: {
                            authkey: this.user_token,
                            sessionid: this.user_id,
                            staffid: this.staff_id
                        }
                    }
                )
                .then(res => {
                    console.log(res);
                    if (res.code === 200) {
                        this.choose_list = res.data;
                    }
                });
        },
        changeRecentSelected(e) {
            var s = e.target.innerText.split("/");
            var f = s.map(function(val, index) {
                return val.trim();
            });
            this.product_classify_selected = f;
            this.dialogRecentVisible = false;
        }
    }
};
</script>
<style lang="scss">
.classify-box {
    white-space: nowrap;
    overflow-x: auto;
    height: 400px;
}
.classify-out {
    display: inline-block;
    width: 300px;
    height: 100%;
    margin: 0 20px 0 0;
    padding: 10px;
    border: 1px solid #f1f1f1;
    vertical-align: top;
    box-sizing: border-box;
    overflow: auto;
}
.classify-item {
    padding: 5px 10px;
    cursor: pointer;
}
.classify-item.active,
.classify-item:hover {
    background: #f1f1f1;
}
</style>